import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EnvelopeRecipients from "./Recipients";
import {
    envelopeFinish,
    getEnvelopeDocumentDetail,
    getEnvelopeRequestInformationDetail,
    removeEnvelopeDocument,
    removeEnvelopeRequestForm,
    removeEnvelopeSignDocument,
    checkMyFilesEnabled,
} from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import EnvelopeDocument from "./Document";
import EnvelopeRequestForm from "./RequestForm";
import SearchRecipient from "./SearchRecipient";
import {
    DATE_FORMAT_LIST,
    NAME_CONVENTION,
    OVERDUE_REMINDER,
    PASSWORD_LIST,
    SEND_REMINDER, SMS_SENDER_LIST, PER_SMS_AMOUNT,
    SYNC_STATUS
} from "../../../../configs/AppConfig";
import DocFormTemplate from "./DocFormTemplate";
import AddEnvelopeTemplate from "../Manage/AddEnvelopeTemplate";
import PdfUploadPopup from "./PdfUploadPopup";
import MakeFillablePopup from "./MakeFillablePopup";
import { Lang } from "../../../../lang";
import DatePicker from "react-datepicker";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";

function EnvelopeStep4(props) {
    const navigate = useNavigate();
    const { uuid, step } = useParams();
    const [senderList, setSenderList] = useState([]);
    const [sendEnvelopeBy, setSendEnvelopeBy] = useState(1);
    const [smsType, setSmsType] = useState(1);
    const [smsAmount, setSmsAmount] = useState(0);
    const [envelopeSenderId, setEnvelopeSenderId] = useState(0);
    const [pastDate, setPastDate] = useState(new Date());
    const [envelopeName, setEnvelopeName] = useState('');
    const [envelopeDate, setEnvelopeDate] = useState('');
    const [clientMessage, setClientMessage] = useState('');
    const [subject, setSubject] = useState('');
    const [emailText, setEmailText] = useState('');
    const [isInvited, setIsInvited] = useState(0);
    const [isEditRecipient, setIsEditRecipient] = useState(false);
    const [isEditDocument, setIsEditDocument] = useState(false);
    const [isEditRequestForm, setIsEditRequestForm] = useState(false);
    const [isEditSignDocumentForm, setIsEditSignDocumentForm] = useState(false);
    const [isAddTemplate, setAddTemplate] = useState(false);
    const [Link, setLink] = useState('');
    const [otp, setOtp] = useState('');
    const [sender, setSender] = useState({ name: '', company: '', email: '', mobile_number: '' });
    const [recipient, setRecipient] = useState({ name: '' });
    const [dueDate, setDueDate] = useState('');

    const [nameConvention, setNameConvention] = useState(1);
    const [syncStatusList, setSyncStatusList] = useState(SYNC_STATUS);
    const [cloudSync, setCloudSync] = useState([]);
    const [sendReminder, setSendReminder] = useState(0);
    const [overdueReminder, setOverdueReminder] = useState(0);
    const [isPassword, setIsPassword] = useState(0);
    const [password, setPassword] = useState('');
    const [referenceId, setReferenceId] = useState('');
    const [nameConventionText, setNameConventionText] = useState('');
    const [cloudSyncText, setCloudSyncText] = useState([]);
    const [sendReminderText, setSendReminderText] = useState('');
    const [overdueReminderText, setOverdueReminderText] = useState('');
    const [passwordText, setPasswordText] = useState('');
    const [referenceText, setReferenceText] = useState('');

    const [signatureDocumentData, setSignatureDocumentData] = useState(null);
    const [directMakeFillableOpen, setDirectMakeFillableOpen] = useState(false);
    const [isMyFilesEnabled, setIsMyFilesEnabled] = useState(true);


    const btnSignDocumentPopup = useRef(null);
    const addTemplateRef = useRef(null);
    const clsAddTemplateRef = useRef(null);
    const openCheckSMSCreditRef = useRef(null);
    const openCloudStorageRef = useRef(null);
    const dueDateRef = useRef(null);
    const signDragItem = useRef();
    const signDragOverItem = useRef();

    const [makeFillable, setMakeFillable] = useState(false);

    const [isAdditionalSetting, setIsAdditionalSetting] = useState(false);

    const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: '' });

    const [recipientData, setRecipientData] = useState({
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        country_id: 227,
        company_name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        address_country_id: "",
        zipcode: "",
    });

    const [docData, setDocData] = useState({
        id: 0,
        request_id: 0,
        doc_name: "",
        doc_detail: "",
        documents: [],
        date_format: 0
    });

    const [requestFormData, setRequestFormData] = useState({
        id: 0,
        request_id: 0,
        form_name: "",
        form_questions: []
    });

    let errorsObj = {
        sender_id: "",
        envelope_name: "",
        envelope_date: "",
        client_message: "",
        recipient: "",
        subject: "",
        email_text: "",
        documents: "",
        fill_forms: "",
        sign_documents: "",
        password: ''
    };
    const [errors, setErrors] = useState(errorsObj);

    const [fromTemplate, setFromTemplate] = useState(1);
    const [isUseFromTemplate, setIsUseFromTemplate] = useState(false);

    const btnDocument = useRef(null);
    const btnRequestForm = useRef(null);
    const docDragItem = useRef();
    const docDragOverItem = useRef();
    const formDragItem = useRef();
    const formDragOverItem = useRef();
    const buttonRef = useRef();

    const [envelope, setEnvelope] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setPastDate(Utils.pastDate());

        if (props?.senderList.length > 0) {
            setSenderList(props.senderList);
        }
        setSendEnvelopeBy((props.formObj.send_envelope_by) ? parseInt(props.formObj.send_envelope_by) : '');
        setEnvelopeSenderId((props.formObj.sender_id) ? props.formObj.sender_id : '');
        setEnvelopeName((props.formObj.envelope_name) ? props.formObj.envelope_name : '');
        setEnvelopeDate((props.formObj.envelope_date) ? props.formObj.envelope_date : '');
        setClientMessage((props.formObj.client_message) ? props.formObj.client_message : '');
        setSubject((props.formObj.subject) ? props.formObj.subject : '');
        setEmailText((props.formObj.email_text) ? props.formObj.email_text : '');

        setSmsType((props.formObj.sms_type) ? parseInt(props.formObj.sms_type) : 1);
        let smsIndex = SMS_SENDER_LIST.findIndex(x => x.id === parseInt(props.formObj.sms_type));
        if (smsIndex > -1) {
            setSmsAmount(SMS_SENDER_LIST[smsIndex]['amount'] * props.formObj.recipient_List.length);
        }

        let ncId = (props.formObj.name_convention) ? props.formObj.name_convention : 1;
        let ncIndex = NAME_CONVENTION.findIndex(x => parseInt(x.id) === parseInt(ncId));
        if (ncIndex > -1) {
            setNameConventionText(NAME_CONVENTION[ncIndex]['value']);
        }
        setNameConvention(parseInt(ncId));
        let csId = (props.formObj.cloud_sync) ? props.formObj.cloud_sync : 0;
        const array = String(csId).split(",").map(Number);

        if (props.formObj.sync_status_list && props.formObj.sync_status_list.length > 0) {
            setSyncStatusList(props.formObj.sync_status_list);
            const csIndex = array.map((value) =>
                props.formObj.sync_status_list.find(x => parseInt(x.id) === value)
            );
            setCloudSyncText(csIndex.map((value) => value.value));
            // if (csIndex > -1) {
            //     setCloudSyncText(props.formObj.sync_status_list[csIndex]['value']);
            // }
            setCloudSync(csIndex.map((value) => value));
        }

        if (parseInt(props.formObj.send_reminder) > -1) {
            let srIndex = SEND_REMINDER.findIndex(x => parseInt(x.id) === parseInt(props.formObj.send_reminder));
            if (srIndex > -1) {
                setSendReminderText(SEND_REMINDER[srIndex]['value']);
            }
            setSendReminder(props.formObj.send_reminder);
        }

        if (parseInt(props.formObj.over_due_reminder) > -1) {
            let orIndex = OVERDUE_REMINDER.findIndex(x => parseInt(x.id) === parseInt(props.formObj.over_due_reminder));
            if (orIndex > -1) {
                setOverdueReminderText(OVERDUE_REMINDER[orIndex]['value']);
            }
            setOverdueReminder(props.formObj.over_due_reminder);
        }

        if (props.formObj.password) {
            setPasswordText('Yes');
            setIsPassword(1);
            setPassword(props.formObj.password);
        } else {
            setPasswordText('No');
            setIsPassword(0);
        }

        if (props.formObj.reference_id) {
            setReferenceText(props.formObj.reference_id);
            setReferenceId(props.formObj.reference_id);
        }

        if (props.formObj.is_use) {
            setIsEditRecipient(true);
            setIsEditDocument(true);
            setIsEditRequestForm(true);
            setIsAdditionalSetting(true);
        }

        // getEnvelopeDetail(uuid).then(res => {
        //     setEnvelope(res.data);
        //     setLoading(false);
        // });

    }, [props]);

    useEffect(() => {
        checkMyFilesEnabled({})
            .then(res => {
                if (res?.data?.data?.myfiles_enabled === true) {
                    setIsMyFilesEnabled(true);
                } else {
                    setIsMyFilesEnabled(false);
                }
            })
            .catch(() => setIsMyFilesEnabled(false));
    }, []);

    const docDragStart = (e, position) => {
        docDragItem.current = position;
    };

    const docDragEnter = (e, position) => {
        docDragOverItem.current = position;
    };

    const formDragStart = (e, position) => {
        formDragItem.current = position;
    };

    const formDragEnter = (e, position) => {
        formDragOverItem.current = position;
    };

    const signDragStart = (e, position) => {
        signDragItem.current = position;
    };

    const signDragEnter = (e, position) => {
        signDragOverItem.current = position;
    };

    const signDrop = (e) => {
        const formData = { ...props.formObj };
        const copyListItems = [...formData.sign_documents];
        const dragItemContent = copyListItems[signDragItem.current];
        copyListItems.splice(signDragItem.current, 1);
        copyListItems.splice(signDragOverItem.current, 0, dragItemContent);
        signDragItem.current = null;
        signDragOverItem.current = null;
        formData.sign_documents = copyListItems;
        props.setFormObj(formData);
    };


    const docDrop = (e) => {
        const formData = { ...props.formObj };
        const copyListItems = [...formData.documents];
        const dragItemContent = copyListItems[docDragItem.current];
        copyListItems.splice(docDragItem.current, 1);
        copyListItems.splice(docDragOverItem.current, 0, dragItemContent);
        docDragItem.current = null;
        docDragOverItem.current = null;
        formData.documents = copyListItems;
        props.setFormObj(formData);
    };

    const onRequestFormEdit = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeRequestInformationDetail(obj)
            .then((response) => {
                let formData = { ...requestFormData };
                formData.id = response.data.data.id;
                formData.request_id = response.data.data.request_id;
                formData.form_name = response.data.data.form_name;
                formData.form_questions = response.data.data.questions;
                setRequestFormData(formData);
                btnRequestForm.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onRequestClone = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeRequestInformationDetail(obj)
            .then((response) => {
                let formData = { ...requestFormData };
                formData.id = 0;
                formData.request_id = response.data.data.request_id;
                formData.form_name = response.data.data.form_name;
                let questionList = response.data.data.questions;
                for (let i = 0; i < questionList.length; i++) {
                    questionList[i]['id'] = 0;
                    for (let j = 0; j < questionList[i]['options'].length; j++) {
                        questionList[i]['options'][j]['id'] = 0;
                    }
                }
                formData.form_questions = questionList;
                setRequestFormData(formData);
                btnRequestForm.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onRequestFormDelete = (e, data) => {
        e.preventDefault();

        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        removeEnvelopeRequestForm(obj)
            .then((response) => {
                let envelopeData = { ...props.formObj };
                let index = envelopeData.fill_forms.findIndex((x) => x.id === obj.id);
                envelopeData.fill_forms.splice(index, 1);
                props.setFormObj(envelopeData);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onDocumentEdit = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeDocumentDetail(obj)
            .then((response) => {
                let formData = { ...docData };
                formData.id = response.data.data.id;
                formData.request_id = response.data.data.request_id;
                formData.doc_name = response.data.data.doc_name;
                formData.doc_detail = response.data.data.doc_detail;
                let files = [];
                for (let i = 0; i < response.data.data.files.length; i++) {
                    files.push({
                        id: response.data.data.files[i]["id"],
                        name: response.data.data.files[i]["file_name"],
                        kb: response.data.data.files[i]["file_size"],
                        path: response.data.data.files[i]["file_path"],
                        file: "",
                    });
                }
                formData.documents = files;
                formData.date_format = response.data.data.date_format;
                setDocData(formData);
                btnDocument.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onDocumentClone = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeDocumentDetail(obj)
            .then((response) => {
                let formData = { ...docData };
                formData.id = 0;
                formData.request_id = response.data.data.request_id;
                formData.doc_name = response.data.data.doc_name;
                formData.doc_detail = response.data.data.doc_detail;
                formData.documents = [];
                formData.date_format = response.data.data.date_format;
                setDocData(formData);
                btnDocument.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onDocumentDelete = (e, data) => {
        e.preventDefault();

        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        removeEnvelopeDocument(obj)
            .then((response) => {
                let envelopeData = { ...props.formObj };
                let index = envelopeData.documents.findIndex((x) => x.id === obj.id);
                envelopeData.documents.splice(index, 1);
                props.setFormObj(envelopeData);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const formDrop = (e) => {
        const formData = { ...props.formObj };
        const copyListItems = [...formData.fill_forms];
        const dragItemContent = copyListItems[formDragItem.current];
        copyListItems.splice(formDragItem.current, 1);
        copyListItems.splice(formDragOverItem.current, 0, dragItemContent);
        formDragItem.current = null;
        formDragOverItem.current = null;
        formData.fill_forms = copyListItems;
        props.setFormObj(formData);
    };

    function onBack(e) {
        e.preventDefault();
        const formData = { ...props.formObj };
        formData.current_step = 3;
        formData.is_use = false;
        props.setFormObj(formData);
        navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/3');
    }

    const cloudeStoragehandleChange = (selectedValues) => {
        if (selectedValues.length > 0) {
            let index = selectedValues.length - 1;
            if (selectedValues[index].id === 0) {
                setCloudSync([{ id: 0, value: "Disabled" }]);
            } else {
                let idx = selectedValues.findIndex(x => x.id === 0);
                if (idx > -1) {
                    selectedValues.splice(idx, 1);
                }
                setCloudSync(selectedValues);
            }
        } else {
            setCloudSync([{ id: 0, value: "Disabled" }]);
        }

    };

    const customStyles = {
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            color: state.isSelected ? "blue" : "dark",
            backgroundColor: "white",
            height: "40px"
        }),
    };
    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                        style={{ marginTop: "-10px" }}
                    />
                    <label style={{ marginTop: "3px", marginLeft: 8, position: "absolute" }}>{props.label}</label>
                </components.Option>
            </div>
        );
    };


    async function onSubmitForm(e, type) {
        e.preventDefault();
        let error = false;
        let errorObj = { ...errorsObj };
        let envelopeFormData = { ...props.formObj };
        if (!envelopeSenderId) {
            errorObj.sender_id = "Please select sender";
            error = true;
        }
        if (!envelopeName) {
            errorObj.envelope_name = "Sleeve name must be required";
            error = true;
        }
        if (!envelopeDate) {
            errorObj.envelope_date = "Please select date";
            error = true;
        }
        if (!clientMessage) {
            errorObj.client_message = "Please enter message";
            error = true;
        }
        if (envelopeFormData.recipient_List.length === 0) {
            errorObj.recipient = "Please add recipient";
            error = true;
        }
        if (!subject) {
            errorObj.subject = "Subject must be required";
            error = true;
        }
        if (!emailText) {
            errorObj.email_text = "Email text must be required";
            error = true;
        }
        //if (envelopeFormData.documents.length === 0 && envelopeFormData.sign_documents.length === 0) {
        if (envelopeFormData.documents.length === 0 && envelopeFormData.fill_forms.length === 0 && envelopeFormData.sign_documents.length === 0) {
            errorObj.documents = "Please create document";
            error = true;
        }

        //Validation of check sign documents fillable or not.
        if (envelopeFormData.sign_documents.length !== 0) {
            let isAllFillable = true;
            for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
                if (envelopeFormData.sign_documents[i].request_id === null) {
                    isAllFillable = false;
                    break;
                }
            }
            if (isAllFillable === false) {
                toast.error("Please make fillable sign request.");
                return false;
            }
        }

        /*
        if (envelopeFormData.sign_documents.length !== 0){
            let checkAnyOneFillable = false;
            for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
                if(envelopeFormData.sign_documents[i].request_id !== ""){
                    checkAnyOneFillable = true;
                    break;
                }
            }
            if(checkAnyOneFillable === false){
                toast.error("Please make fillable sign request.");
                return false;
            }
        }
        */

        if (parseInt(isPassword) === 1 && !password) {
            errorObj.password = 'Please enter password';
            error = true;
        }

        setErrors(errorObj);

        setTimeout(function () {
            let classList = document.getElementsByClassName('text-danger');
            if (classList.length > 0) {
                let scrollDiv = classList[0].getBoundingClientRect().top + window.scrollY - 200;
                window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
            }
        }, 0);

        if (error) return;

        let recipientIds = "";
        for (let i = 0; i < envelopeFormData.recipient_List.length; i++) {
            recipientIds += envelopeFormData.recipient_List[i]["id"];
            if (envelopeFormData.recipient_List.length !== i + 1) {
                recipientIds += ",";
            }
        }

        const cloudOption = (cloudSync.map((i) => i.id).join(','));

        envelopeFormData.submit_type = type;
        envelopeFormData.sender_id = envelopeSenderId;
        envelopeFormData.envelope_name = envelopeName;
        envelopeFormData.envelope_date = envelopeDate;
        envelopeFormData.client_message = clientMessage;
        envelopeFormData.subject = subject;
        envelopeFormData.email_text = emailText;
        envelopeFormData.recipient_ids = recipientIds;
        envelopeFormData.name_convention = nameConvention;
        envelopeFormData.cloud_sync = cloudOption;
        envelopeFormData.send_reminder = sendReminder;
        envelopeFormData.over_due_reminder = overdueReminder;
        envelopeFormData.reference_id = referenceId;

        if (parseInt(isPassword) === 1) {
            envelopeFormData.password = password;
        } else {
            envelopeFormData.password = '';
        }

        props.setLoading(true);

        let ipAddress = '';
        await Utils.getIpAddress().then(response => {
            ipAddress = response;
        });

        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
        envelopeFormData.time_zone = (timeZone) ? timeZone : '';
        envelopeFormData.ip_address = ipAddress;

        envelopeFinish(envelopeFormData)
            .then((response) => {
                if (type === 1) {
                    navigate("/manage/draft");
                    toast.success(response.data.message);
                } else {
                    envelopeFormData.is_done = true;
                    props.setFormObj(envelopeFormData);
                    setIsInvited(1);
                    setLink(response.data.link);
                    setOtp(response.data.otp);
                    // Store additional response data
                    setSender(response.data.sender || { name: '', company: '', email: '', mobile_number: '' });
                    setRecipient(response.data.recipient || { name: '' });
                    setDueDate(response.data.due_date || '');
                    toast.success(response.data.message);
                }
                props.setLoading(false);
            })
            .catch((err) => {
                props.setLoading(false);
                if (err.response.status === 411) {
                    openCheckSMSCreditRef?.current.click();
                } else if (err.response.status === 415) {
                    openCloudStorageRef?.current.click();
                } else {
                    toast.error(Utils.getErrorMessage(err));
                }
            });
    }

    function onRemoveRecipient(e, index) {
        e.preventDefault();
        const formData = { ...props.formObj };
        formData.recipient_List.splice(index, 1);
        props.setFormObj(formData);
    }

    function onEditRecipient(e, obj) {
        e.preventDefault();
        let formData = { ...recipientData };
        formData.id = obj.id;
        formData.first_name = obj.first_name;
        formData.last_name = obj.last_name;
        formData.email = obj.email;
        formData.mobile = obj.mobile;
        formData.country_id = obj.country_id;
        formData.company_name = obj.company_name;
        formData.address_1 = obj.address_1;
        formData.address_2 = obj.address_2;
        formData.city = obj.city;
        formData.state = obj.state;
        formData.address_country_id = obj.address_country_id;
        formData.zip_code = obj.zip_code;
        setRecipientData(formData);
        buttonRef.current?.click();
    }

    function onEnvelopeStart(e) {
        e.preventDefault();
        navigate("/client-portal");
    }

    function onViewEnvelope(e) {
        e.preventDefault();
        const envelopeFormData = { ...props.formObj };
        navigate("/manage/" + envelopeFormData.envelope_uuid);
    }

    function onViewSmartEnvelope(e) {
        e.preventDefault();
        const envelopeFormData = { ...props.formObj };
        navigate("/manage/" + envelopeFormData.envelope_uuid);
    }

    function onAddTemplate(e) {
        e.preventDefault();
        const envelopeFormData = { ...props.formObj };
        setDeleteEnvelope({ id: envelopeFormData.envelope_id, name: envelopeFormData.envelope_name });
    }


    const goToHome = (e) => {
        clsAddTemplateRef?.current.click();
        navigate("/client-portal");
    };

    const handlePassword = (e) => {
        setIsPassword(e.target.value);
        setPassword('');
    };

    const handleUseDocFormTemplate = (e, type) => {
        e.preventDefault();

        setFromTemplate(type);
        setIsUseFromTemplate(true);
    };

    const handleEnvInput = (e, type) => {

        let envelopeData = { ...props.formObj };

        if (type === 'name') {
            setEnvelopeName(e.target.value);
            envelopeData.envelope_name = e.target.value;
        } else if (type === 'date') {
            setEnvelopeDate(e);
            envelopeData.envelope_date = e;
        } else if (type === 'message') {
            setClientMessage(e.target.value);
            envelopeData.client_message = e.target.value;
        } else if (type === 'subject') {
            setSubject(e.target.value);
            envelopeData.subject = e.target.value;
        } else if (type === 'email_text') {
            setEmailText(e.target.value);
            envelopeData.email_text = e.target.value;
        } else if (type === 'send_envelope_by') {
            envelopeData.send_envelope_by = e.target.value;
            if (e.target.value === "1") {
                setSmsType(1);
                setSmsAmount(0);
                envelopeData.sms_type = 1;
            }
        } else if (type === 'sms_type') {
            envelopeData.send_envelope_by = 2; // 2 use for selected email and SMS
            let smsTypeList = [...SMS_SENDER_LIST];
            let index = smsTypeList.findIndex(x => parseInt(x.id) === parseInt(e.target.value));
            if (index > -1) {
                setSmsAmount(smsTypeList[index]['amount'] * props.formObj.recipient_List.length);
            }
            envelopeData.sms_type = e.target.value;
        }

        props.setFormObj(envelopeData);
    };

    const showDate = (date) => {
        let dateFormat = '';
        if (date) {
            dateFormat = new Date(date);
        }
        return dateFormat;
    };

    const showDateFormat = (id) => {
        let value = '';
        let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
        if (index > -1) {
            value = DATE_FORMAT_LIST[index]['format'];
        }
        return value;
    };

    const showDatePlaceholder = (id) => {
        let value = '';
        let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
        if (index > -1) {
            value = DATE_FORMAT_LIST[index]['text'];
        }
        return value;
    };

    //SignDocument Functions
    const handleDownload = async (e, obj) => {
        e.preventDefault();
        props.setLoading(true);
        await Utils.downloadAnyFile(obj.path, obj.file_name);
        props.setLoading(false);
    };


    const onRequestSignDocumentDelete = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        removeEnvelopeSignDocument(obj)
            .then((response) => {
                let envelopeData = { ...props.formObj };
                let index = envelopeData.sign_documents.findIndex((x) => x.id === obj.id);
                envelopeData.sign_documents.splice(index, 1);
                props.setFormObj(envelopeData);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };


    const onRequestSignDocumentRender = (e, data) => {
        console.log("Render make fillable form");
        e.preventDefault();

        const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
        keysToRemove.forEach(key => localStorage.removeItem(key));

        props.setLoading(true);
        setSignatureDocumentData(data);
        setMakeFillable(true);
        btnSignDocumentPopup.current?.click();

    };


    const handleMakeFillable = () => {
        let current = (makeFillable === false) ? true : false;
        setMakeFillable(current);
    }


    useEffect(() => {
        const makeFillableAsync = async () => {
            if (directMakeFillableOpen === true) {
                const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
                keysToRemove.forEach(key => localStorage.removeItem(key));
                await setMakeFillable(true);
                btnSignDocumentPopup.current?.click();
                setDirectMakeFillableOpen(false);
            }
        };

        makeFillableAsync(); // Call the async function
    }, [directMakeFillableOpen]);

    const handleCopyLink = (e) => {
        e.preventDefault();
        if (Link) {
            // Create a formatted string with envelope details
            const formattedData = `
Dear ${recipient.name},
I hope you are doing well.

Please upload the required documents by visiting the following link:
🔗 ${Link}

You will need to enter the following access code to proceed:
🔐 Access Code: ${otp}

Kindly complete this request before ${dueDate}
If you have any questions or face any issues, feel free to reach out.

Best regards,
${sender.name}
${sender.company}
📞 ${sender.mobile_number}
📧 ${sender.email}
            `.trim();

            navigator.clipboard.writeText(formattedData)
                .then(() => {
                    toast.success("Link copied to clipboard!");
                })
                .catch((err) => {
                    toast.error("Failed to copy link.");
                    console.error("Copy failed:", err);
                });
        } else {
            toast.error("No link available to copy.");
        }
    };

    // if (loading) return <div>Loading...</div>;

    // Now you have envelope.is_smart_sleeve
    // if (step === "2") {
    //     if (envelope.is_smart_sleeve) {
    //         return <SmartSleeveStep2Component envelope={envelope} />;
    //     } else {
    //         return <NormalStep2Component envelope={envelope} />;
    //     }
    // }

    // Helper to get initials from name
    function getInitials(firstName, lastName) {
        if (!firstName && !lastName) return '';
        return ((firstName ? firstName[0] : '') + (lastName ? lastName[0] : '')).toUpperCase();
    }

    // Prepare sender options for react-select
    const senderOptions = senderList.map(item => ({
        value: Number(item.id),
        label: `${item.first_name} ${item.last_name} (${item.email})`,
        data: item,
    }));
    const selectedSenderOption = senderOptions.find(opt => opt.value === Number(envelopeSenderId)) || null;

    return (
        <>
            {isInvited === 1 &&
                <div className="sleeve-gradient-bg-step mt-0">
                    <div className="container">
                        <div className="sleeve-success-card card shadow-lg rounded-lg p-4 d-flex flex-column align-items-center">
                            {/* Success Icon */}
                            <div className="sleeve-success-icon d-flex justify-content-center align-items-center mb-3">
                                <i className="bi bi-check2-circle"></i>
                            </div>
                            {/* Main Message */}
                            <h2 className="sleeve-success-title fw-bold text-center mb-2">Sleeve Sent Successfully!</h2>


                            {/* Save as Template Card */}
                            <div className="sleeve-template-card w-100 mb-4">
                                <div className="d-flex align-items-center p-3 rounded">
                                    {/* <div className="sleeve-template-icon d-flex justify-content-center align-items-center me-3">
                                        <i className="bi bi-stars"></i>
                                    </div> */}
                                    <div className="w-100">
                                        <div className="sleeve-template-title fw-semibold">Save as Template</div>
                                        <div className="sleeve-template-desc text-muted">
                                            Save this sleeve as a template for future projects. Instantly reuse it without having to recreate the sleeve from scratch
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {Link && (
                                <div className="text-center mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleCopyLink}
                                        data-toggle="tooltip"
                                        title="Copy the link to clipboard"
                                    >
                                        <i className="bi bi-clipboard me-2"></i> Copy Link
                                    </button>
                                </div>
                            )}
                            {/* Save as Template Button - full width, blue */}
                            {!isAddTemplate && (
                                <div className="w-80 mx-auto mb-3">
                                    {/* <button
                                        type="button"
                                        className="sleeve-template-btn fw-semibold d-flex align-items-center justify-content-center"
                                        data-toggle="modal"
                                        data-target="#AddEnvelopeTemplate"
                                        onClick={onAddTemplate}
                                    > */}
                                    <button type="button" className="sleeve-template-btn fw-semibold d-flex align-items-center justify-content-center"
                                        data-toggle="tooltip" title={Lang.env_add_to_template}
                                        data-bs-toggle="modal" data-bs-target="#AddEnvelopeTemplate"
                                        onClick={onAddTemplate}><i className="bi bi-bookmark-plus me-2" />Save as Template</button>

                                </div>
                            )}

                            {/* Two side-by-side buttons */}
                            <div className="w-100 d-flex gap-3 mb-2 sleeve-action-btn-group">
                                <button
                                    className="sleeve-action-btn sleeve-action-btn-outline fw-semibold d-flex align-items-center justify-content-center"
                                    data-toggle="tooltip"
                                    title={Lang.env_view_envelope}
                                    onClick={onViewEnvelope}
                                >
                                    <i className="bi bi-eye me-2"></i> View Sleeve
                                </button>

                                <button
                                    className="sleeve-action-btn sleeve-action-btn-dark fw-semibold d-flex align-items-center justify-content-center"
                                    data-toggle="tooltip"
                                    title={Lang.env_create_another}
                                    onClick={onEnvelopeStart}
                                >
                                    <i className="bi bi-plus-circle me-2"></i> Create New
                                </button>
                            </div>

                            {/* <div className="w-100 text-center mt-3">
                                <a href="#" className="sleeve-dashboard-link text-muted" onClick={onEnvelopeStart}>
                                    Continue to Dashboard <i className="bi bi-arrow-right ms-1"></i>
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            }
            {isInvited === 0 &&
                <div className="sleeve-gradient-bg-main sleeve-step">
                    <div className="sleeve-container">
                        <div className="sleeve-send-section-bg">
                            <h2 className="sleeve-section-title">
                                <i className="bi bi-send" style={{ color: '#8d35c9', fontSize: '1.6rem', marginRight: '8px' }}></i>
                                Send Sleeve By
                            </h2>
                            <div className="sleeve-send-methods">
                                <div className={`sleeve-method-card${sendEnvelopeBy === 1 ? ' sleeve-method-active' : ''}`}>
                                    <label htmlFor="sleeve-method-email" className="sleeve-step-label sleeve-method-label">
                                        <div>
                                            <input
                                                type="radio"
                                                name="sleeve-method"
                                                id="sleeve-method-email"
                                                value={1}
                                                checked={sendEnvelopeBy === 1}
                                                onChange={(e) => handleEnvInput(e, 'send_envelope_by')}
                                                className="sleeve-step-input sleeve-method-radio"
                                            />
                                        </div>

                                        <div className="sleeve-method-content">
                                            <div className="sleeve-method-header">
                                                <span className="sleeve-method-title">
                                                    <i className="bi bi-envelope-paper" style={{ color: '#8d35c9', fontSize: '1.3rem', marginRight: '8px' }}></i>
                                                    Email Only
                                                </span>
                                                <span className="sleeve-method-credit">1 Sleeve Credit</span>
                                            </div>
                                            <div className="sleeve-method-desc">
                                                Send Sleeve Via Email Only. Recipients will receive Email - Email will have link to upload the Documents.
                                            </div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`sleeve-method-card${sendEnvelopeBy === 2 ? ' sleeve-method-active' : ''}`}>
                                    <label htmlFor="sleeve-method-sms" className="sleeve-step-label sleeve-method-label">
                                        <div>
                                            <input
                                                type="radio"
                                                name="sleeve-method"
                                                id="sleeve-method-sms"
                                                value={2}
                                                checked={sendEnvelopeBy === 2}
                                                onChange={(e) => handleEnvInput(e, 'send_envelope_by')}
                                                className="sleeve-step-input sleeve-method-radio"
                                            />
                                        </div>

                                        <div className="sleeve-method-content">
                                            <div className="sleeve-method-header">
                                                <span className="sleeve-method-title">
                                                    <i className="bi bi-chat-dots" style={{ color: '#1dbf73', fontSize: '1.3rem', marginRight: '8px' }}></i>
                                                    Email and SMS
                                                </span>
                                                <span className="sleeve-method-credit sleeve-method-credit-sms">1 Sleeve Credit + {Math.round(smsAmount / PER_SMS_AMOUNT)} SMS</span>
                                            </div>
                                            <div className="sleeve-method-desc">
                                                Send Sleeve via Email & SMS. Recipients will receive Email & SMS - Both have links to respond to Documents.
                                            </div>
                                            <div className="sleeve-method-sms-types">
                                                <label htmlFor="sleeve-sms-type" className="sleeve-step-label sleeve-method-sms-label">
                                                    SMS Types
                                                    <i className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                                                        aria-hidden="true"
                                                        data-toggle="tooltip"
                                                        data-placement="right"
                                                        title={Lang.env_sms_type}
                                                    />
                                                </label>
                                                <select
                                                    className="sleeve-step-input sleeve-method-sms-select"
                                                    aria-label="Select SMS Type"
                                                    value={smsType}
                                                    onChange={(e) => handleEnvInput(e, 'sms_type')}
                                                    id="sleeve-sms-type"
                                                >
                                                    {SMS_SENDER_LIST.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.value}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* Remove grid and columns, stack all blocks in one column */}
                        <div className="sleeve-step4-single-col">
                            {/* Sleeve Sender */}
                            <div className="sleeve-section-card">
                                <h2 className="sleeve-section-title">
                                    <i className="bi bi-person" />
                                    <span>
                                        Your Email Address (Sender)
                                        <i className="bi bi-info-circle ms-1 text-muted cursor-pointer fs-5" aria-hidden="true" data-toggle="tooltip"
                                            data-placement="left" title="This is the email used to send the document request. You can select from your verified addresses." />
                                    </span>
                                </h2>
                                <div className="sleeve-section-content">
                                    <ReactSelect
                                        classNamePrefix="sleeve-sender-select"
                                        value={selectedSenderOption}
                                        onChange={option => setEnvelopeSenderId(option ? Number(option.value) : 0)}
                                        options={senderOptions}
                                        placeholder="Select sender"
                                        isSearchable
                                        formatOptionLabel={option => (
                                            <div className="sleeve-sender-option">
                                                <div className="sleeve-sender-initials">
                                                    {getInitials(option.data.first_name, option.data.last_name)}
                                                </div>
                                                <div>
                                                    <div className="sleeve-sender-name">{option.data.first_name} {option.data.last_name}</div>
                                                    <div className="sleeve-sender-email">{option.data.email}</div>
                                                </div>
                                            </div>
                                        )}
                                        styles={{}}
                                    />
                                    {errors.sender_id && (
                                        <div className="sleeve-error-message">{errors.sender_id}</div>
                                    )}
                                </div>
                            </div>
                            {/* Sleeve Details */}
                            <div className="sleeve-section-card">
                                <h2 className="sleeve-section-title">
                                    <i className="bi bi-file-earmark-text" style={{ color: '#8d35c9', fontSize: '1.3rem', marginRight: '8px' }}></i>
                                    Sleeve Details
                                </h2>
                                <div className="sleeve-section-content">
                                    <div className="sleeve-details-row">
                                        <div className="sleeve-details-col">
                                            <label htmlFor="envelop_name" className="sleeve-step-label sleeve-label">
                                                Sleeve Name
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right"
                                                    title={'Name this document request for easy identification later. Example: "IT Returns 2025" or "Loan Docs - March."'} />
                                            </label>
                                            <input type="text" className="sleeve-step-input sleeve-input" id="envelop_name"
                                                onChange={(e) => handleEnvInput(e, 'name')}
                                                value={envelopeName}
                                                aria-describedby="emailHelp" placeholder="Enter Sleeve Name" />
                                            {errors.envelope_name && (
                                                <div className="sleeve-error-message">{errors.envelope_name}</div>
                                            )}
                                        </div>
                                        <div className="sleeve-details-col">
                                            <label htmlFor="due_date" className="sleeve-step-label sleeve-label">
                                                Due Date
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right"
                                                    title="The recipient should upload all requested documents by this date. Optional, but helps set expectations." />
                                            </label>
                                            <div className="position-relative">
                                                <DatePicker
                                                    selected={showDate(envelopeDate)}
                                                    dateFormat={showDateFormat(1)}
                                                    minDate={pastDate} ref={dueDateRef}
                                                    className="sleeve-step-input sleeve-input"
                                                    placeholderText={showDatePlaceholder(1)}
                                                    onChange={(date) => handleEnvInput(date, 'date')} />
                                                <i
                                                    className="bi bi-calendar"
                                                    style={{
                                                        position: "absolute",
                                                        right: "16px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#888",
                                                    }}
                                                    onClick={(e) => dueDateRef?.current.setFocus(true)} />
                                            </div>
                                            {errors.envelope_date && (
                                                <div className="sleeve-error-message">{errors.envelope_date}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="sleeve-details-row">
                                        <div className="sleeve-details-col-full">
                                            <label className="sleeve-step-label sleeve-label">
                                                Client Portal Message
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right"
                                                    title="This message is shown to the recipient. Use it to explain what documents you need and any special instructions." />
                                            </label>
                                            <textarea className="sleeve-step-textarea sleeve-input" rows={6}
                                                placeholder="Enter Message to Client"
                                                onChange={(e) => handleEnvInput(e, 'message')}
                                                value={clientMessage} />
                                            {errors.client_message && (
                                                <div className="sleeve-error-message">{errors.client_message}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Recipient Details */}
                            <div className="sleeve-section-card">
                                <div className="sleeve-section-header-flex">
                                    <h2 className="sleeve-section-title">
                                        <i className="bi bi-people me-2"></i>
                                        Recipient Details
                                    </h2>

                                    {isEditRecipient && (
                                        <div className="d-flex flex_wrap mb-2">
                                            <button type="button" className="btn search-btn-template me-2"
                                                data-bs-toggle="offcanvas" data-bs-target="#SearchRecipients"
                                                aria-controls="SearchRecipients" data-toggle="tooltip" title=""
                                                data-bs-original-title="click to Search">
                                                <i className="bi bi-search me-3" /> Search Recipients
                                            </button>

                                            <button type="button" className="step2-add-btn ms-auto w-100"
                                                data-bs-toggle="offcanvas" data-bs-target="#addRecipients"
                                                aria-controls="addRecipients" data-toggle="tooltip"
                                                title={Lang.env_add_recipient}
                                                ref={buttonRef}>
                                                <span className="me-3">+</span>Add Recipients
                                            </button>
                                        </div>
                                    )}
                                    {!isEditRecipient && (
                                        <span className="custom-edit-btn" onClick={(e) => setIsEditRecipient(true)}>
                                            <i className="bi bi-pencil-fill me-1" aria-hidden="true" /> Edit
                                        </span>
                                    )}
                                </div>
                                <div className="sleeve-section-content text-dark">
                                    {props.formObj.recipient_List.map((item, index) => (
                                        <div className="sleeve-recipient-item">
                                            <div className="sleeve-recipient-info">
                                                <div className="sleeve-recipient-name">{item.first_name + " " + item.last_name}</div>
                                                <div className="sleeve-recipient-email">{item.email}</div>
                                            </div>
                                            <div className="sleeve-recipient-mobile">{Utils.mobileFormat(item)}</div>
                                            <div className="sleeve-recipient-actions">
                                                {isEditRecipient && (
                                                    <span className="action-btn"
                                                        onClick={(e) => { e.stopPropagation(); onEditRecipient(e, item); }}>
                                                        <i className="bi bi-pencil-fill cur-pointer" aria-hidden="true" data-toggle="tooltip" title="click to edit" />
                                                    </span>
                                                )}
                                                {isEditRecipient && (
                                                    <span className="sleeve-delete-icon" onClick={(e) => onRemoveRecipient(e, index)}>
                                                        <i className="bi bi-x-circle cur-pointer" aria-hidden="true" />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {errors.recipient && (<div className="sleeve-error-message">{errors.recipient}</div>)}
                                </div>
                            </div>
                            {/* Email Details */}
                            <div className="sleeve-section-card">
                                <h2 className="sleeve-section-title">
                                    <i className="bi bi-envelope-at" style={{ color: '#8d35c9', fontSize: '1.3rem', marginRight: '8px' }}></i>
                                    Email Details
                                </h2>
                                <div className="sleeve-section-content">
                                    <div className="sleeve-details-row">
                                        <div className="sleeve-details-col-full">
                                            <label htmlFor="email_subject" className="sleeve-step-label sleeve-label">
                                                Subject
                                                <i className="bi bi-info-circle ms-1" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_subject} />
                                            </label>
                                            <input type="text" className="sleeve-step-input sleeve-input" id="email_subject"
                                                aria-describedby="emailHelp" value={subject}
                                                onChange={(e) => handleEnvInput(e, 'subject')}
                                                placeholder="Enter Email Subject" />
                                            {errors.subject && (<div className="sleeve-error-message">{errors.subject}</div>)}
                                        </div>
                                    </div>
                                    <div className="sleeve-details-row">
                                        <div className="sleeve-details-col-full">
                                            <label htmlFor="email_text" className="sleeve-step-label sleeve-label">
                                                Email Text
                                                <i className="bi bi-info-circle ms-1" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_email_text} />
                                            </label>
                                            <textarea className="sleeve-step-textarea sleeve-input" id="email_text" rows={8} value={emailText}
                                                onChange={(e) => handleEnvInput(e, 'email_text')}
                                                placeholder="Enter Email text box" />
                                            {errors.email_text && (<div className="sleeve-error-message">{errors.email_text}</div>)}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Document Request -*/}
                            <div className="sleeve-section-card sleeve-doc-request-card">
                                <div className="sleeve-section-header-flex justify-content-between align-items-center mb-2">
                                    <h2 className="sleeve-section-title mb-0 d-flex align-items-center">
                                        <i className="bi bi-folder2-open me-2"></i>
                                        Document Request
                                    </h2>
                                    {isEditDocument && (
                                        <div className="d-flex flex_wrap">
                                            {props?.isTemplate === true && (
                                                <button type="button" className="btn search-btn-template me-2"
                                                    data-bs-toggle="offcanvas" data-bs-target="#AddDocFormTemplate"
                                                    onClick={(e) => handleUseDocFormTemplate(e, 1)}
                                                    data-toggle="tooltip" title={Lang.env_add_doc_template}>
                                                    Add From Templates
                                                </button>
                                            )}
                                            <button type="button" className="step2-add-btn ms-auto w-100"
                                                data-bs-toggle="offcanvas" data-bs-target="#Add-document"
                                                ref={btnDocument} aria-controls="Add-document" data-toggle="tooltip"
                                                title={Lang.env_add_document}>
                                                <span className="me-3">+</span>Add Request
                                            </button>
                                        </div>
                                    )}
                                    {!isEditDocument && (
                                        <span className="custom-edit-btn" onClick={(e) => setIsEditDocument(true)}>
                                            <i className="bi bi-pencil-fill me-1" aria-hidden="true" /> Edit
                                        </span>
                                    )}
                                </div>
                                <div className="mt-2 mb-3">
                                    {props.formObj.documents.map((item, index) => (
                                        <h2 key={index} className="request_document_tab  mb-2">
                                            <div className="d-flex justify-content-between flex_wrap">
                                                <div className="accordion_text" style={{ cursor: "grab" }}
                                                    onDragStart={(e) => docDragStart(e, index)}
                                                    onDragEnter={(e) => docDragEnter(e, index)} onDragEnd={docDrop}
                                                    draggable>
                                                    <img src="/images/dots_rectangle.webp" alt="rectangle" className="me-3" />
                                                    {item.name}
                                                </div>
                                                <div className="functional_icons">
                                                    {parseInt(item.request_id) === 0 ? (
                                                        <span className="functional_icon_round">
                                                            <i className="bi bi-people-fill" data-toggle="tooltip"
                                                                data-placement="right" title="" data-bs-original-title="Everyone"
                                                                aria-hidden="true" />
                                                        </span>
                                                    ) : (
                                                        <>
                                                            {item.request_display.map((recipient, i) =>
                                                                <span key={i} className="functional_icon_round"
                                                                    data-toggle="tooltip" data-placement="right" title=""
                                                                    data-bs-original-title={recipient.full_name}>{recipient.display}</span>
                                                            )}
                                                        </>
                                                    )}
                                                    {isEditDocument && (
                                                        <span>
                                                            <i onClick={(e) => onDocumentEdit(e, item)}
                                                                className="bi bi-pencil-fill me-3 cur-pointer" aria-hidden="true"
                                                                data-toggle="tooltip" title="click me to edit"
                                                                data-bs-original-title="click me to add edit" />
                                                        </span>
                                                    )}
                                                    {isEditDocument && (
                                                        <span>
                                                            <i onClick={(e) => onDocumentClone(e, item)}
                                                                className="bi bi-copy me-3 cur-pointer" aria-hidden="true"
                                                                data-toggle="tooltip" title="click me to copy"
                                                                data-bs-original-title="click me to copy" />
                                                        </span>
                                                    )}
                                                    {isEditDocument && (
                                                        <span>
                                                            <i onClick={(e) => onDocumentDelete(e, item)}
                                                                className="bi bi-trash cur-pointer" aria-hidden="true"
                                                                data-toggle="tooltip" title="click me to delete"
                                                                data-bs-original-title="click me to delete" />
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </h2>
                                    ))}
                                    {errors.documents && (
                                        <div className="text-danger">{errors.documents}</div>
                                    )}
                                </div>
                            </div>
                            {/* Information Request (Form Builder) - Modern Card UI */}
                            {props.formObj.fill_forms && props.formObj.fill_forms.length > 0 && (
                                <div className="sleeve-section-card sleeve-info-request-card">
                                    <div className="sleeve-section-header-flex justify-content-between align-items-center mb-2">
                                        <h2 className="sleeve-section-title mb-0 d-flex align-items-center">
                                            <i className="bi bi-ui-checks-grid me-2" ></i>
                                            Information Request (Form Builder)
                                        </h2>
                                        {isEditRequestForm && (
                                            <div className="d-flex flex_wrap">
                                                {props?.isTemplate === true && (
                                                    <button type="button" className="btn search-btn-template me-2"
                                                        data-bs-toggle="offcanvas" data-bs-target="#AddDocFormTemplate"
                                                        onClick={(e) => handleUseDocFormTemplate(e, 3)}
                                                        data-toggle="tooltip" title={Lang.env_add_data_template}>
                                                        Add From Templates
                                                    </button>
                                                )}
                                                <button type="button" className="step2-add-btn ms-auto w-100"
                                                    data-bs-toggle="offcanvas" data-bs-target="#MakeForm"
                                                    aria-controls="MakeForm" data-toggle="tooltip"
                                                    title={Lang.env_add_question} ref={btnRequestForm}>
                                                    <span className="me-3">+</span>Create a Form
                                                </button>
                                            </div>
                                        )}
                                        {!isEditRequestForm && (
                                            <span className="custom-edit-btn" onClick={(e) => setIsEditRequestForm(true)}>
                                                <i className="bi bi-pencil-fill" aria-hidden="true" /> Edit
                                            </span>
                                        )}
                                    </div>
                                    <div className="mt-2 mb-3">
                                        {props.formObj.fill_forms.map((item, index) => (
                                            <h2 key={index} className="request_document_tab yellow mb-2">
                                                <div className="d-flex justify-content-between flex_wrap">
                                                    <div className="accordion_text" style={{ cursor: "grab" }}
                                                        onDragStart={(e) => formDragStart(e, index)}
                                                        onDragEnter={(e) => formDragEnter(e, index)}
                                                        onDragEnd={formDrop}
                                                        draggable>
                                                        <img src="/images/dots_rectangle.webp" alt="image4"
                                                            className="me-3" />
                                                        {item.name}
                                                    </div>
                                                    <div className="functional_icons">
                                                        {parseInt(item.request_id) === 0 ? (
                                                            <span className="functional_icon_round">
                                                                <i className="bi bi-people-fill" data-toggle="tooltip"
                                                                    data-placement="right" title=""
                                                                    data-bs-original-title="Everyone" aria-hidden="true" />
                                                            </span>
                                                        ) : (
                                                            <>
                                                                {item.request_display.map((recipient, i) =>
                                                                    <span key={i} className="functional_icon_round"
                                                                        data-toggle="tooltip" data-placement="right"
                                                                        title=""
                                                                        data-bs-original-title={recipient.full_name}>{recipient.display}</span>
                                                                )}
                                                            </>
                                                        )}
                                                        {isEditRequestForm && (
                                                            <span>
                                                                <i onClick={(e) => onRequestFormEdit(e, item)}
                                                                    className="bi bi-pencil-fill me-3 cur-pointer"
                                                                    aria-hidden="true" data-toggle="tooltip"
                                                                    title="click me to edit"
                                                                    data-bs-original-title="click me to edit" />
                                                            </span>
                                                        )}
                                                        {isEditRequestForm && (
                                                            <span>
                                                                <i onClick={(e) => onRequestClone(e, item)}
                                                                    className="bi bi-copy me-3 cur-pointer"
                                                                    aria-hidden="true" data-toggle="tooltip"
                                                                    title="click me to copy"
                                                                    data-bs-original-title="click me to copy" />
                                                            </span>
                                                        )}
                                                        {isEditRequestForm && (
                                                            <span>
                                                                <i onClick={(e) => onRequestFormDelete(e, item)}
                                                                    className="bi bi-trash cur-pointer" aria-hidden="true"
                                                                    data-toggle="tooltip" title="click me to delete"
                                                                    data-bs-original-title="click me to delete" />
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </h2>
                                        ))}
                                        {errors.fill_forms && (
                                            <div className="text-danger">{errors.fill_forms}</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* Signature Request - Modern Card UI */}
                            {props.formObj.sign_documents && props.formObj.sign_documents.length > 0 && (
                                <div className="sleeve-section-card sleeve-sign-request-card">
                                    <div className="sleeve-section-header-flex justify-content-between align-items-center mb-2">
                                        <h2 className="sleeve-section-title mb-0 d-flex align-items-center">
                                            <i className="bi bi-pencil-square me-2" ></i>
                                            Signature Request
                                        </h2>
                                        {isEditSignDocumentForm && (
                                            <div className="d-flex flex_wrap">

                                                {/* {props?.isTemplate === true && (
                                            <button type="button" className="btn shadow load_template_btn me-2"
                                                    data-bs-toggle="offcanvas" data-bs-target="#AddDocFormTemplate"
                                                    onClick={(e) => handleUseDocFormTemplate(e, 2)}
                                                    data-toggle="tooltip" title={Lang.env_add_data_template}>
                                                Add From Templates
                                            </button>
                                        )} */}

                                                <button type="button" className="step2-add-btn ms-auto w-100" data-bs-toggle="offcanvas"
                                                    data-bs-target="#pdfUploadForm" data-toggle="tooltip">
                                                    <span className="me-3">+</span>Create a Form
                                                </button>
                                            </div>
                                        )}
                                        {!isEditSignDocumentForm && (
                                            <span className="custom-edit-btn" onClick={(e) => setIsEditSignDocumentForm(true)}>
                                                <i className="bi bi-pencil-fill" aria-hidden="true" /> Edit
                                            </span>
                                        )}
                                    </div>
                                    <div className="mt-2 mb-3">
                                        {props.formObj.sign_documents.map((item, index) => (
                                            <h2 key={index} className={(index + 1 === props.formObj.sign_documents.length) ? "request_document_tab dt-alert-info mb-0" : "request_document_tab dt-alert-info mb-2"}>
                                                <div className="d-flex justify-content-between flex_wrap align-items-center">
                                                    <div className="accordion_text" style={{ cursor: "grab" }}
                                                        onDragStart={(e) => signDragStart(e, index)}
                                                        onDragEnter={(e) => signDragEnter(e, index)} onDragEnd={signDrop} draggable>
                                                        <img src="/images/dots_rectangle.webp" alt="image4" className="me-3" />
                                                        {item.name}
                                                    </div>

                                                    <div className="functional_icons d-flex align-items-center">
                                                        {parseInt(item.request_id) === 0 ? (
                                                            <span className="functional_icon_round">
                                                                <i className="bi bi-people-fill" data-toggle="tooltip" data-placement="right"
                                                                    title="" data-bs-original-title="Everyone" aria-hidden="true" />
                                                            </span>
                                                        ) : (
                                                            <>
                                                                {item.request_display.map((recipient, i) =>
                                                                    <span key={i} className="functional_icon_round"
                                                                        data-toggle="tooltip" data-placement="right" title=""
                                                                        data-bs-original-title={recipient.full_name}>{recipient.display}</span>
                                                                )}
                                                            </>
                                                        )}
                                                        {isEditSignDocumentForm && (
                                                            <span className="d-none" ref={btnSignDocumentPopup} data-bs-toggle="offcanvas"
                                                                data-bs-target="#makeFillableForm" ></span>
                                                        )}

                                                        {/* {
                                                        (isEditSignDocumentForm && item.request_id === "") &&
                                                        <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn me-3 cur-pointer">
                                                             <i className="bi bi-pencil-square" data-toggle="tooltip" data-placement="right"
                                                                title="" data-bs-original-title="Make fillable" aria-hidden="true"> Make fillable</i>
                                                        </span>
                                                    }
                                                    {
                                                        (isEditSignDocumentForm && item.request_id !== "") &&
                                                        <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn edit_live_form_btn me-3 cur-pointer">
                                                             <i className="bi bi-pencil-square" data-toggle="tooltip" data-placement="right"
                                                                title="" data-bs-original-title="Edit Live Form" aria-hidden="true"> Edit Live Form</i>
                                                        </span>
                                                    } */}


                                                        {isEditSignDocumentForm && item.request_id === "" && (
                                                            <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn me-3 cur-pointer" >
                                                                <i className="bi bi-pencil-square" data-toggle="tooltip" data-placement="right"
                                                                    title="" data-bs-original-title="Make fillable" aria-hidden="true" /> Make fillable
                                                            </span>
                                                        )}

                                                        {isEditSignDocumentForm && item.request_id !== "" && (
                                                            <span onClick={(e) => onRequestSignDocumentRender(e, item)} className="make_fillable_btn edit_live_form_btn me-3 cur-pointer" >
                                                                <i className="bi bi-pencil-square" data-toggle="tooltip" data-placement="right"
                                                                    title="" data-bs-original-title="Edit Live Form" aria-hidden="true" /> Edit Live Form
                                                            </span>
                                                        )}

                                                        {isEditSignDocumentForm && (
                                                            <span className="functional_icon_round">
                                                                <i className="bi bi-download cur-pointer" onClick={(e) => handleDownload(e, item)} data-toggle="tooltip" data-placement="right"
                                                                    title="" data-bs-original-title="Download" aria-hidden="true" />
                                                            </span>
                                                        )}

                                                        {isEditSignDocumentForm && (
                                                            <span>
                                                                <i onClick={(e) => onRequestSignDocumentDelete(e, item)}
                                                                    className="bi bi-trash cur-pointer" aria-hidden="true"
                                                                    data-toggle="tooltip" title="click me to delete"
                                                                    data-bs-original-title="click me to delete" />
                                                            </span>
                                                        )}

                                                    </div>
                                                </div>
                                            </h2>
                                        ))}
                                        {errors.sign_documents && (
                                            <div className="text-danger">{errors.sign_documents}</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* Additional Settings (view/edit) */}
                            {!isAdditionalSetting && (
                                <div className="sleeve-section-card sleeve-additional-settings-card">
                                    <div className="sleeve-section-header-flex justify-content-between align-items-center mb-2">
                                        <h2 className="sleeve-section-title mb-0 d-flex align-items-center">
                                            <i className="bi bi-gear me-2 text-primary" ></i>
                                            Additional Settings
                                        </h2>
                                        <span className="custom-edit-btn fs-6" data-toggle="tooltip" title="click me to edit"
                                            onClick={(e) => setIsAdditionalSetting(true)} data-bs-original-title="click me to edit">
                                            <i className="bi bi-pencil-fill" aria-hidden="true" /> Edit
                                        </span>
                                    </div>
                                    <div className="sleeve-section-content">
                                        <div className="row mb-2">
                                            <div className="col-lg-4 font_bold">Naming Convention:</div>
                                            <div className="col-lg-8 font-light">{nameConventionText}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-lg-4 font_bold">Cloud Storage Sync:</div>
                                            <div className="col-lg-8 font-light">{cloudSyncText.join(' , ')}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-lg-4 font_bold">Send Reminder (Email):</div>
                                            <div className="col-lg-8 font-light">{sendReminderText}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-lg-4 font_bold">Overdue Reminder (Email):</div>
                                            <div className="col-lg-8 font-light">{overdueReminderText}</div>
                                        </div>
                                        <div className="row mb-2 d-none">
                                            <div className="col-lg-4 font_bold">Password Protected:</div>
                                            <div className="col-lg-8 font-light">{passwordText}</div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-lg-4 font_bold">Reference ID:</div>
                                            <div className="col-lg-8 font-light">{referenceText}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isAdditionalSetting && (
                                <div className="sleeve-section-card sleeve-additional-settings-card">
                                    <div className="sleeve-section-header-flex justify-content-between align-items-center mb-2">
                                        <h2 className="sleeve-section-title mb-0 d-flex align-items-center">
                                            <i className="bi bi-gear me-2" style={{ color: '#8d35c9', fontSize: '1.5rem' }}></i>
                                            Additional Settings
                                        </h2>
                                    </div>
                                    <div className="sleeve-section-content">
                                        <div className="row mb-3">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Naming Convention:</label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <select className="sleeve-input" value={nameConvention}
                                                    onChange={(e) => setNameConvention(e.target.value)}
                                                    aria-label="Default select example">
                                                    {NAME_CONVENTION.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.value}</option>
                                                    )}
                                                </select>
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right"
                                                    title={Lang.env_naming_convention} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Cloud Storage Sync:</label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <ReactSelect
                                                    className="form-check w-100 ps-0"
                                                    value={cloudSync}
                                                    styles={customStyles}
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    onChange={cloudeStoragehandleChange}
                                                    options={syncStatusList}
                                                    getOptionLabel={options => options['value']}
                                                    components={{
                                                        Option
                                                    }}
                                                />
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_cloud_sync} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Send Reminder (Email):</label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <select className="sleeve-input" value={sendReminder}
                                                    onChange={(e) => setSendReminder(e.target.value)}
                                                    aria-label="Default select example">
                                                    {SEND_REMINDER.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.value}</option>
                                                    )}
                                                </select>
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_send_reminder} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Overdue Reminder (Email):</label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <select className="sleeve-input" value={overdueReminder}
                                                    onChange={(e) => setOverdueReminder(e.target.value)}
                                                    aria-label="Default select example">
                                                    {OVERDUE_REMINDER.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.value}</option>
                                                    )}
                                                </select>
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right"
                                                    title={Lang.env_overdue_reminder} />
                                            </div>
                                        </div>
                                        <div className="row mb-3 d-none">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Password Protected: </label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <select className="sleeve-input" value={isPassword} onChange={handlePassword}
                                                    aria-label="Default select example">
                                                    {PASSWORD_LIST.map((item, index) =>
                                                        <option key={index} value={item.id}>{item.value}</option>
                                                    )}
                                                </select>
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_password} />
                                            </div>
                                        </div>
                                        {isPassword > 0 &&
                                            <div className="row mb-3">
                                                <div className="col-lg-4">
                                                    <label className="form-label mb-2">&nbsp;</label>
                                                </div>
                                                <div className="col-lg-8 d-flex align-items-center">
                                                    <input type="password" value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        className="sleeve-input" placeholder="Enter password" />
                                                    <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                        data-toggle="tooltip" data-placement="right" title={Lang.env_password} />
                                                </div>
                                                {errors.password &&
                                                    <div className="col-lg-8 offset-lg-4">
                                                        <div className="text-danger mt-1">{errors.password}</div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <div className="row mb-1">
                                            <div className="col-lg-4">
                                                <label className="form-label mt-2">Reference ID:</label>
                                            </div>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                <input type="text" value={referenceId}
                                                    onChange={(e) => setReferenceId(e.target.value)}
                                                    className="sleeve-input" />
                                                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true"
                                                    data-toggle="tooltip" data-placement="right" title={Lang.env_reference} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="sleeve-step-buttons bg-white" style={{ padding: '20px', borderRadius: '6px' }}>
                                <button type="button" onClick={onBack} className="sleeve-btn-back">Back</button>
                                <div className="sleeve-step-buttons-right">
                                    <button type="button" data-toggle="tooltip" title={Lang.env_save_exit}
                                        onClick={(e) => onSubmitForm(e, 1)} className="sleeve-btn-save">Save & Exit
                                    </button>
                                    <button type="button" data-toggle="tooltip" title={Lang.env_send}
                                        onClick={(e) => onSubmitForm(e, 2)} className="sleeve-btn-next">Send Sleeve
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <button type="button" ref={addTemplateRef} data-toggle="modal" className="d-none"
                data-target="#addToTemplateModal" />
            <div className="modal fade" id="addToTemplateModal" tabIndex="-1" aria-labelledby="addToTemplateModalLabel"
                aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addToTemplateModalLabel">Added in Templates.</h5>
                            <button type="button" className="btn btn-close close_btn text-reset mb-2"
                                ref={clsAddTemplateRef} data-bs-dismiss="modal" aria-label="Close">
                                <i className="bi bi-x-circle" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="py-2 mb-0">You have Successfully added this Sleeve in Templates.</p>
                        </div>
                        <div className="modal-footer ">
                            <button type="button" onClick={goToHome} className="btn btn-primary">Go to Home</button>
                        </div>
                    </div>
                </div>
            </div>

            <DocFormTemplate fromTemplate={fromTemplate} setFromTemplate={setFromTemplate}
                formObj={props.formObj} setFormObj={props.setFormObj}
                isUseFromTemplate={isUseFromTemplate} setIsUseFromTemplate={setIsUseFromTemplate} />

            <AddEnvelopeTemplate deleteEnvelope={deleteEnvelope} setDeleteEnvelope={setDeleteEnvelope}
                setLoading={props.setLoading} setAddTemplate={setAddTemplate} />

            <span data-toggle="modal" data-target="#openCheckSMSCredit" ref={openCheckSMSCreditRef} />
            <div className="modal fade" id="openCheckSMSCredit" tabIndex={-1}
                aria-labelledby="openCheckSMSCreditLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p className="py-2">You don't have enough SMS credit, click on Billing to purchase extra SMS
                                Credits.</p>
                        </div>
                        <div className="modal-footer ">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <span data-toggle="modal" data-target="#openCloudStorage" ref={openCloudStorageRef} />
            <div className="modal fade" id="openCloudStorage" tabIndex={-1}
                aria-labelledby="openCloudStorageLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p className="py-2">Now, cloud storage not connected. Please connect the cloud storage.</p>
                        </div>
                        <div className="modal-footer ">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Render EnvelopeRecipients and SearchRecipient offcanvas at the bottom */}
            <EnvelopeRecipients
                formObj={props.formObj}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
                recipData={recipientData}
                setRecipData={setRecipientData}
                buttonRef={buttonRef}
            />
            <SearchRecipient
                formObj={props.formObj}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
            />
            <EnvelopeDocument
                formObj={props.formObj}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
                docData={docData}
                setDocData={setDocData}
            />
            <EnvelopeRequestForm
                formObj={props.formObj}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
                requestFormData={requestFormData}
                setRequestFormData={setRequestFormData}
            />
            <PdfUploadPopup
                formObj={props.formObj}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
                setDirectMakeFillableOpen={setDirectMakeFillableOpen}
                setSignatureDocumentData={setSignatureDocumentData}
                isMyFilesEnabled={isMyFilesEnabled}
            />
            <MakeFillablePopup
                formObj={props.formObj}
                signatureDocumentData={signatureDocumentData}
                setFormObj={props.setFormObj}
                setLoading={props.setLoading}
                makeFillable={makeFillable}
                handleMakeFillable={handleMakeFillable}
            />
        </>
    );
}

export default EnvelopeStep4;
